// extracted by css-extract-rspack-plugin
module.exports =  {"footerText":"ReviewPromptDialog__footerText___O0w4T"};